import { LucideIcon } from "lucide-react";
import { LangLink as Link } from "@/components/LangLink";
import { useTranslation } from "react-i18next";

type ApplicationCardProps = {
  title: string;
  description: string;
  image: string;
  icon: LucideIcon;
  index: number;
  href?: string;
};

export function ApplicationCard({
  title,
  description,
  image,
  icon: Icon,
  href,
}: ApplicationCardProps) {
  const { t } = useTranslation("common");

  return (
    <div className="group overflow-hidden rounded-3xl border border-white/10 bg-white/[0.03] transition duration-500 hover:bg-white/[0.06]">
      <div className="relative h-[260px] overflow-hidden">
        <img
          src={image}
          alt={title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
        />

        <div className="absolute inset-0 bg-gradient-to-t from-[#070707] via-black/20 to-transparent" />
      </div>

      <div className="p-8">
        <Icon className="mb-10 h-9 w-9 text-white/80 transition group-hover:text-accent" />

        <h3 className="display text-3xl uppercase text-white">{title}</h3>

        <p className="mt-5 text-lg leading-relaxed text-white/60">{description}</p>

        {href && (
          <Link
            to={href as any}
            className="mt-8 inline-flex items-center text-md font-semibold uppercase tracking-wider text-accent transition hover:text-white"
          >
            {t("learnMore", "Learn More")} →
            <span className="sr-only"> about {title}</span>
          </Link>
        )}
      </div>
    </div>
  );
}
